import { DropdownMenuItem } from "@/components/atoms/DropdownMenuItem/DropdownMenuItem";
import { IconButton } from "@/components/atoms/IconButton/IconButton";
import { DropdownMenu } from "@/components/molecules/DropdownMenu/DropdownMenu";
import { Button } from "@/overlay/components/CommonParts/buttons";
import { t } from "@lingui/core/macro";
import { useMemo, useRef, useState } from "react";

type TableExportMenuProps = {
  onExportCsv: () => void;
  onExportPdf: () => void;
};

export function TableExportMenu({ onExportCsv, onExportPdf }: TableExportMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const menuItems = useMemo(
    () => [
      {
        id: "export-csv",
        label: t`Export CSV`,
        iconName: "download",
        onSelect: onExportCsv,
      },
      {
        id: "export-pdf",
        label: t`Export PDF`,
        iconName: "picture_as_pdf",
        onSelect: onExportPdf,
      },
    ],
    [onExportCsv, onExportPdf],
  );

  const toggleMenu = () => setIsOpen((currentlyOpen) => !currentlyOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <div className="table-export-menu" ref={anchorRef}>
      <Button type="button" icon="download" onClick={toggleMenu} aria-haspopup="menu" aria-expanded={isOpen}>
        {t`Export`}
      </Button>
      <IconButton
        iconName="more_vert"
        size="large"
        ariaLabel={t`Open export options`}
        className="table-export-menu__trigger"
        onClick={toggleMenu}
      />
      <DropdownMenu
        isOpen={isOpen}
        withinPortal={true}
        placement="bottom-end"
        anchorRef={anchorRef}
        onClose={closeMenu}
      >
        {menuItems.map((item) => (
          <DropdownMenuItem
            key={item.id}
            label={item.label}
            iconName={item.iconName}
            testId={`options-item-${item.id}`}
            onClick={() => {
              item.onSelect();
              closeMenu();
            }}
          />
        ))}
      </DropdownMenu>
    </div>
  );
}
